import { Loader2 } from 'lucide-react';
import { VoiceTab } from '../phone/tabs/VoiceTab';
import { usePhoneSettingsForm } from '../phone/PhoneSettingsContext';
import { SectionFrame } from './SectionFrame';

export function VoiceSection() {
  const { form, setForm, loading } = usePhoneSettingsForm();
  return (
    <SectionFrame
      title="Stimme & Sprache"
      description="STT-Engine, TTS-Stimme, Sprachausgabe-Parameter und Spracheinstellung."
    >
      {loading ? (
        <div className="flex h-32 items-center justify-center text-muted-foreground">
          <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Lade …
        </div>
      ) : (
        <VoiceTab form={form} setForm={setForm} />
      )}
    </SectionFrame>
  );
}
